import { UserStatus } from "../application/store/settings.store";

export const OnlineStatus: UserStatus = {
  id: 0,
  description: "Disponível",
  active: true,
};
